class SignInDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SignInDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderSignInIconAccessibility();
  }

  setHeaderSignInIconAccessibility() {
    const signInLinks = document.querySelectorAll('[sign-in-trigger]');
    signInLinks.forEach((signInLink) => {
      signInLink.setAttribute('role', 'button');
      signInLink.setAttribute('aria-haspopup', 'dialog');
      signInLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(signInLink)
      });
      signInLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(signInLink);
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('SignInDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('sign-in-drawer', SignInDrawer);